import Notify from 'quasar/src/plugins/Notify.js';
import _ from 'lodash'

export function perfectApiResult (result) {
  const defOptions = {
    type: result.success ? 'positive' : (result.error ? 'negative' : 'warning'),
    message: result.message ?? (result.success ? '操作成功' : (result.error ? '请求服务端时发生错误' : '操作失败'))
  }
  function notify (options) {
    let notifyOptions
    if (options instanceof Function) {
      notifyOptions = options(defOptions, result)
    } else {
      notifyOptions = Object.assign(defOptions, _.isString(options) ? { message: options } : options)
    }
    // 不显示后端堆栈信息
    if (notifyOptions.message?.length > 32 && notifyOptions.message.includes('java')) {
      console.warn('未显示后端响应的错误信息(可能包括堆栈信息)', notifyOptions)
      notifyOptions.message = '服务端发生错误'
    }
    if (notifyOptions) {
      Notify.create(notifyOptions)
    }
    return result
  }
  function none () {
    return result
  }
  result.notify = notify
  result.notifyIfFail = result.success ? none : notify
  result.notifyIfError = result.error ? notify : none
  return result
}
